import React from 'react';
import { ButtonPrimary, IconChevronDown } from '@spotify-internal/encore-web';
import { useCallback } from 'react';
import styled from 'styled-components';
const ScrollDownBtnPosition = styled.div `
  position: absolute;
  bottom: 1rem;
  left: 50%;
  translate: -50% 0;
`;
export const ScrollDownNotificationController = ({ notifications, messageContainerRef, }) => {
    const handleClick = useCallback(() => {
        var _a;
        (_a = messageContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0, behavior: 'smooth' });
    }, [messageContainerRef]);
    if (notifications <= 0)
        return null;
    return (React.createElement(ScrollDownBtnPosition, null,
        React.createElement(ButtonPrimary, { iconLeading: IconChevronDown, size: "small", colorSet: "announcement", onClick: handleClick }, notifications)));
};
